import Vue from 'vue'
import KeyMirror from 'keymirror'
import store from '@/store'
import types from '@/store/mutation-types'

export function updateVueObject (object, path, newValue, remove = false) {
  while (path.length > 1) {
    object = object[path.shift()]; // eslint-disable-line
  }
  if (remove) {
    Vue.delete(object, path)
  } else {
    Vue.set(object, path.shift(), newValue)
  }
}

export function forceUpdateVueObject (object, path, newValue) {
  while (path.length > 1) {
    const thisPath = path.shift()
    if (object[thisPath] === undefined) {
      Vue.set(object, thisPath, {})
    }
    object = object[thisPath]; // eslint-disable-line
  }
  Vue.set(object, path.shift(), newValue)
}

function loopRestState (storeNameArr) {
  storeNameArr.forEach(value => {
    store.commit(`${value}/${types.RESET_STATE}`)
  })
}

function appendSearchResultStoreArr (restStoreArr) {
  restStoreArr.push('ccd', 'ecircular', 'dashboard', 'hotb', 'listNavigation', 'projectContractors', 'projects', 'tenancyRecords', 'tenantProject', 'tenders', 'workPermit', 'tables')
  return restStoreArr
}

export function resetSearchResultStore () {
  const restStoreArr = appendSearchResultStoreArr([])
  loopRestState(restStoreArr)
}

export function resetStore () {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem('id')
  }
  resetForm()
  const restStoreArr = ['access', 'user', 'regions', 'buildings', 'settings']
  appendSearchResultStoreArr(restStoreArr)
  loopRestState(restStoreArr)
}

export function resetStoreWhenLogout () {
  resetStore()
  store.commit(`settings/${types.LOGOUT_RESET_STATE}`)
  store.commit(`currencies/${types.LOGOUT_RESET_STATE}`)
  store.commit(`regions/${types.CROSS_REGION_LOGIN}`, false)
}

export function resetForm () {
  store.commit(`form/${types.RESET_STATE}`)
}

export const DATA_CACHE_KEYS = KeyMirror({
  VIEW_ALL_TR: null,
  VIEW_ALL_HOTB: null,
  VIEW_ALL_TP: null,
  VIEW_ALL_TENDER: null,
  VIEW_ALL_PROJECT: null,
})
